<app-layouts *ngIf="!maintenancePage"></app-layouts>
<app-maintenance-page *ngIf="maintenancePage"></app-maintenance-page>